import { EyeIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useScope } from '../../contexts/ScopeContext';

/** One working-scope picker. It grants no access and never selects a process. */
export default function PhaseScopeSelector({ align = 'end' } = {}) {
  const { phaseScope } = useScope();
  if (!phaseScope?.enabled) return null;
  const { options, selectedKey, label, setScopeChoice, ready, loading, error, fromCache, retry } = phaseScope;
  return <details className={`dropdown shrink-0 ${align === 'start' ? 'dropdown-start' : 'dropdown-end'}`}>
    <summary className="btn btn-ghost btn-xs min-h-0 h-7 rounded-full gap-1.5" aria-label={`Scope: ${label}`}>
      <EyeIcon className="w-4 h-4" aria-hidden="true" />{label}<ChevronDownIcon className="w-3 h-3" aria-hidden="true" />
    </summary>
    <div className="dropdown-content z-50 mt-2 w-64 rounded-box border border-base-300 bg-base-100 p-2 shadow-lg">
      <div role="menu" aria-label="Working scope" className="flex flex-col gap-1">
        {options.map(option => <button key={option.key} type="button" role="menuitemradio"
          aria-checked={option.key === selectedKey} disabled={!ready}
          className={`btn btn-sm justify-start h-auto min-h-9 whitespace-normal text-left ${option.key === selectedKey ? 'btn-primary' : 'btn-ghost'}`}
          onClick={event => { setScopeChoice(option.key); event.currentTarget.closest('details').open = false; }}>
          {option.label}
        </button>)}
      </div>
      {loading && <p role="status" className="mt-2 text-xs">Loading scope…</p>}
      {!loading && !error && fromCache && !ready && <p role="status" className="mt-2 text-xs">Loading scope…</p>}
      {error && <div role="alert" className="mt-2 text-xs"><p>Scope settings could not be loaded.</p>
        <button type="button" className="btn btn-ghost btn-xs mt-1" onClick={retry}>Retry scope</button></div>}
    </div>
  </details>;
}
